import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService, NbSearchService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { EnvService } from 'src/app/env.service';
import { liveSearch } from '../dash.operator';
import { DashService } from '../dash.service';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import { PasswordDialogComponent } from 'src/app/password-dialog/password-dialog.component';

@Component({
  selector: 'app-hub-transferv2',
  templateUrl: './hub-transferv2.component.html',
  styleUrls: ['./hub-transferv2.component.css']
})
export class HubTransferV2Component implements OnInit {
  custInfo: any;
  fromHubId = "N/A"
  fromUser = "N/A"
  toUser = ""
  searchValue = " "
  custDatas = [];
  showSearchCard = false;
  isLoading = false;
  ownerHubs = "";

  constructor(public userDetails: UserDetailComponent, private route: ActivatedRoute, private http: HttpClient, private router: Router, public dashService: DashService, private env: EnvService,private dialogService:NbDialogService) {
  }


  ngOnInit(): void {
    this.verifyUser()
  }

  removeNonAlphaNumeric(str) {
    return str.replace(/[^a-zA-Z0-9@._%+-]/g, "");
  }

  verifyUser() {
    this.dialogService.open(PasswordDialogComponent)
    .onClose.subscribe((password: string | null) => {
      if (password !== null) {
        this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
        .subscribe(response => {
          console.log(response)
          this.userDetails.showToast(3000, response['message'], 'validating')
          this.route.params.subscribe(params => {
            console.log(params.hubIds)
            this.ownerHubs = params.hubIds;
            this.fromUser = params.hubIds.split("|")[params.hubIds.split("|").length-1]
            console.log("this.fromuser",this.fromUser);
            
          });
          setTimeout(() => {
            let newTerm = this.removeNonAlphaNumeric(this.searchValue);
            console.log(this.searchValue,"new Term:",newTerm);
            this.searchUsers(newTerm)
            // this.isLoading = false;
          }, 1500);
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
      } else {
        
      }
    });
  }


  transferAll = false;
  selectedHubIds :string[] = [];

  getOwnerHubs():string{
    return this.ownerHubs;
  }

  getAllHubIds():string[] {
    let hubs = this.ownerHubs.split("|")
    hubs.pop();
    return hubs;
  }

  markTransferAll(checked: boolean) {
    this.transferAll = checked;
  }

  toggleHub(checked,index){
    let hubId = this.getAllHubIds()[index];
    if(checked){
      if(!this.selectedHubIds.includes(hubId)){
        this.selectedHubIds.push(hubId);
      }
    }else {
      let index = this.selectedHubIds.indexOf(hubId);
      this.selectedHubIds.splice(index,1);
    }
    console.log(this.selectedHubIds);
    
  }

  removeAcls = false;

  transfer() {
    if(this.selectedHubIds.length == 0){
      this.userDetails.showToast(3000,"Failed HUB Transfer","Please select at least one HUB")
      return
    }
    this.isLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/transferV2?fromUser="+this.fromUser,{fromHubIds:this.selectedHubIds,toUser:this.toUser,removeAcls:this.removeAcls})
      .subscribe(response => {
        console.log(response);
        this.userDetails.showToast(2000, "Transferred Successfully", "hub transferred to new account");
        setTimeout(() => {
          this.isLoading = false
          this.router.navigate(['users']);
        }, 2000);
      }, err => {
        this.isLoading = false
        console.log(err);
      })
  }

  searchUsers(query: string) {
    // console.log("search Users: " + query)
    this.searchValue = query
    this.userQuerySubject.next(this.searchValue + "," + false + "," + false + ',' + 0 + "," + 10);
  }

  private userQuerySubject = new Subject<string>();

  readonly custDatas$ = this.userQuerySubject.pipe(
    liveSearch(query => this.dashService.fetchUsers(query))
  );

  setData(item: any) {
    this.toUser = item['emailId'] ? item['emailId'] : item['mobile'];
    this.showSearchCard = false;
  }

}
